module.exports = __webpack_public_path__ + "static/media/winLarge91_1.86464ce4.svg";